import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { parseValidators, convertTrueFalseStringToBoolean } from '../util';
import FormRow from './FormRow';
var nonAlphaNumeric = /[^a-zA-Z0-9]/g;
var defaultCheckedFunction = function defaultCheckedFunction(optionValue, value) {
  return optionValue === value;
};
var Radio = function Radio(_ref) {
  var label = _ref.label,
    name = _ref.name,
    options = _ref.options,
    description = _ref.description,
    validators = _ref.validators,
    required = _ref.required,
    messages = _ref.messages,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? defaultCheckedFunction : _ref$checked,
    _ref$shouldUnregister = _ref.shouldUnregister,
    shouldUnregister = _ref$shouldUnregister === void 0 ? false : _ref$shouldUnregister,
    _ref$onChange = _ref.onChange,
    customOnChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$dataTrack = _ref.dataTrack,
    dataTrack = _ref$dataTrack === void 0 ? null : _ref$dataTrack,
    _ref$dataTrackAction = _ref.dataTrackAction,
    dataTrackAction = _ref$dataTrackAction === void 0 ? null : _ref$dataTrackAction,
    _ref$dataTrackLabel = _ref.dataTrackLabel,
    dataTrackLabel = _ref$dataTrackLabel === void 0 ? null : _ref$dataTrackLabel;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    description: description,
    label: options ? label : undefined,
    name: name,
    required: typeof required !== 'undefined' ? required : !!validators,
    styles: styles
  }, /*#__PURE__*/React.createElement(Controller, {
    shouldUnregister: shouldUnregister,
    name: name,
    control: control,
    rules: parseValidators({
      messages: messages,
      validators: validators
    }),
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        _onChange = _ref2$field.onChange,
        _onBlur = _ref2$field.onBlur,
        value = _ref2$field.value,
        fieldName = _ref2$field.name;
      return options.map(function (option, i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-check ".concat(styles.formCheck ? styles.formCheck : ''),
          key: option.value
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          className: "form-check-input",
          name: fieldName,
          "data-cy": fieldName,
          "data-track": dataTrack,
          "data-track-action": dataTrackAction,
          "data-track-label": dataTrackLabel,
          id: "".concat(name).concat(i).replace(nonAlphaNumeric, ''),
          onChange: function onChange(e) {
            var value = convertTrueFalseStringToBoolean(e.target.value);
            customOnChange(value);
            return _onChange(value);
          },
          onBlur: function onBlur(e) {
            return _onBlur(convertTrueFalseStringToBoolean(e.target.value));
          },
          value: option.value,
          checked: checked(option.value, value)
        }), /*#__PURE__*/React.createElement("label", {
          className: "form-check-label",
          htmlFor: "".concat(name).concat(i).replace(nonAlphaNumeric, '')
        }, option.label));
      });
    }
  }));
};
export default Radio;